import { Component, h, Host } from '@stencil/core';

@Component({
  tag: 'pn-product-card',
  styleUrl: 'pn-product-card.scss',
})
export class PnProductCard {
  render() {
    return (
      <Host>
        <slot name="illustration" />
        <div class="cardcontent">
          <div class="details">
            <slot name="title" />
            <slot name="content" />
            <div class="info">
              <slot />
            </div>
            <slot name="note" />
            <slot name="additionalUSP" />
          </div>
          <div class="cardprice">
            <slot name="cardprice" />
            <slot name="mobiledownload"></slot>
            <slot name="servicepoint"></slot>
          </div>
        </div>
      </Host>
    );
  }
}
